export class IllustrationUtils {
    static getBorder(): string {
        return localStorage.getItem('drawSize') ? localStorage.getItem('drawSize') : '1';
    }

    static getColor(): string {
        return localStorage.getItem('drawColor') ? localStorage.getItem('drawColor') : '#000000';
    }

    static setBorder(val: string) {
        localStorage.setItem('drawSize', val);
    }

    static setColor(val: string) {
        localStorage.setItem('drawColor', val);
    }
}